// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/css/main.ba485ecb.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"652":"31d6cfe0","723":"3f231666"}[chunkId] + ".css";
};